import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-10 md:py-14 px-6" style={{
    background: 'linear-gradient(180deg, #1A0A0A 0%, #200808 50%, #1A0A0A 100%)',
    borderTop: '1px solid rgba(220, 60, 60, 0.15)',
    borderBottom: '1px solid rgba(220, 60, 60, 0.15)'
  }} data-id="element-244">
      <div className="max-w-md mx-auto text-center" data-id="element-245">
        <AlertTriangleIcon className="w-8 h-8 text-red-400/80 mx-auto" strokeWidth={1.5} data-id="element-246" />

        <p className="text-red-400/90 font-body font-bold text-xs uppercase tracking-[0.2em] mt-3" data-id="element-247">
          Precio de lanzamiento
        </p>

        <p className="text-brand-muted font-body text-sm md:text-base leading-relaxed mt-4" data-id="element-248">
          Precio normal:{' '}
          <span className="text-brand-ivory line-through" data-id="element-249">$41.920</span> → Hoy:{' '}
          <span className="text-brand-gold font-bold" data-id="element-250">$19.990</span>
        </p>

        <p className="text-brand-muted font-body text-sm leading-relaxed mt-2" data-id="element-251">
          Cuando tengamos suficientes testimonios, vuelve a{' '}
          <strong className="text-brand-ivory" data-id="element-252">$34.990</strong>. Puede ser
          mañana.
        </p>
      </div>
    </section>;
}